export default class ProductGroup {
  constructor(args) {
    this.parent = args.parent;
    this.user = args.user;
    this.element = args.element;
    this.data = args.data;
    this.translations = args.translations;
    this.baseTargetUrl = args.baseTargetUrl;
    this.element.classList.add('product-group');

    this.render();
  }

  addEvents() {
    this.backToTopButton.addEventListener('click', _ => window.scrollTo(0, 0));
  }

  render() {
    this.element.innerHTML = this.template;
    this.list = this.element.querySelector('ul');
    this.backToTopButton = this.element.querySelector('.button-back-to-top');

    this.addEvents();
  }

  getTitleAttrValue(product) {
    if (this.parent.canViewAllNumbers) {
      return `
        ${product.name} (${this.translations.addresses}: ${product.assigned_addresses} / ${this.translations.offers}: ${product.dynamic_offer_amount + product.contract_offer_amount} / ${this.translations.requests}: ${product.request_amount})
      `
    }

    if (this.parent.canViewNumAddresses) {
      return `${product.name} (${this.translations.addresses}: ${product.assigned_addresses})`;
    }

    return product.name;
  }

  getLinkLabel(product) {
    if (this.parent.canViewAllNumbers) {
      return `
        ${product.name}
        (${product.assigned_addresses}/${product.dynamic_offer_amount + product.contract_offer_amount}/${product.request_amount})
      `
    }

    if (this.parent.canViewNumAddresses) {
      return `${product.name} (${product.assigned_addresses})`;
    }

    return product.name;
  }

  get template() {
    return `
      <span class="product-group-anchor" id="${this.data.headline}"></span>
      <h3>${this.data.headline}</h3>
      <div>
        <ul class="no-bullet">
          ${this.data.products.map(product => `
            <li>
              <a href="${this.baseTargetUrl}&v=${product.name}" title="${this.getTitleAttrValue(product)}">
                ${this.getLinkLabel(product)}
              </a>
            </li>
          `).join('')}
        </u>
      </div>
      <a class="button-back-to-top">
        <i class="fas fa-arrow-circle-up"></i>
        <span>${this.translations.toTop}</span>
      </a>
    `;
  }
}